import _ from 'lodash'
function titlecase (value) {
  return _.startCase(_.toLower(value.replace('_', ' ')))
}

export default titlecase
